import Box from '@app/components/common/Box';
import { layoutContentStyles } from './styles';
import useScrollRestoration from '@app/hooks/useScrollRestoration';
import { TCsx } from '@emotion/react';

interface ILayoutContent {
  children: React.ReactNode;
  noPadding?: boolean;
  csx?: TCsx;
}

const LayoutContent = ({
  children,
  noPadding = false,
  ...others
}: ILayoutContent) => {
  useScrollRestoration('layout-content');
  useScrollRestoration('items-list');
  return (
    <Box csx={[layoutContentStyles(noPadding)]} {...others} id="layout-content">
      {children}
    </Box>
  );
};

export default LayoutContent;
